{
	"title": "{{productName}} transaction history",
	"item": {
		"time": "Time",
		"description": "Description",
		"transactionId": "Transaction ID",
		"showIds": "Show IDs",
		"depositTitle": "Assurance by DNV, allowing a carbon bank deposit",
		"depositDescription": "Once the 3rd party assurance body 'DNV' has assured the stored captured carbon volume in a digital Monitor-Report-Verify system, a new deposit is made in the carbon bank.",
		"withdrawalTitle": "Invoice to supplier, triggering a carbon bank withdrawal",
		"withdrawalDescription": "With the invoicing of evoZero material to the supplier, a withdrawal from the carbon bank has been executed.",
		"transferTitle": "Transfer of carbon reductions to declaration holder",
		"transferDescription": "The supplier initiated the transfer of the carbon reductions to the declaration holder, based on the evoZero material volume that went in to the delivered product."
	},
	"proofIdsModal": {
		"titleTransactions": "View transactions",
		"titleMeasurements": "View measurements",
		"paragraph1": "One transaction step on the {{productName}} involves aggregating transactions on the distributed ledger. Below, you will find a list of links to third-party services where you can view these transactions.",
		"paragraph2": "Please note that these links will take you to external websites that provide transaction viewing capabilities.",
		"open": "Open",
		"close": "Close"
	},
	"errors": {
		"fetch": "Could not fetch activity history"
	}
}
